import { render, staticRenderFns } from "./RecentNews.vue?vue&type=template&id=f2260b68&scoped=true&"
import script from "./RecentNews.vue?vue&type=script&lang=js&"
export * from "./RecentNews.vue?vue&type=script&lang=js&"
import style1 from "./RecentNews.vue?vue&type=style&index=1&id=f2260b68&scoped=true&lang=css&"
import style2 from "./RecentNews.vue?vue&type=style&index=2&id=f2260b68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2260b68",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardSubtitle,VCardTitle,VCol,VDivider,VImg,VRow})
